import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { RegistroContent } from "./Registro.jsx";

export default function RegistroModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="max-w-3xl w-[95vw] sm:w-[92vw] max-h-[92vh] overflow-y-auto p-0 bg-[#0e2618] border-[#f7f7f4]/10 rounded-2xl text-[#f7f7f4]"
        data-testid="registro-modal"
      >
        <DialogTitle className="sr-only">Registro EUZERONE</DialogTitle>
        <DialogDescription className="sr-only">
          Únete a la comunidad EUZERONE y obtén tu cupón y muestra gratuita
        </DialogDescription>
        {/* Decorative glows */}
        <div className="absolute inset-0 pointer-events-none opacity-25 overflow-hidden rounded-2xl">
          <div className="absolute -top-40 -right-40 w-[400px] h-[400px] rounded-full bg-[#b45f3e]/30 blur-3xl" />
          <div className="absolute -bottom-40 -left-40 w-[400px] h-[400px] rounded-full bg-[#9ead9b]/20 blur-3xl" />
        </div>
        <div className="relative">
          <RegistroContent variant="modal" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
